import styled from 'styled-components';

import { spacing } from '../../../../atoms/spacing';
import { color } from '../../../../atoms/colors';
import { font } from '../../../../atoms/typography';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing[16]};
  border-radius: ${spacing[16]};
  background: ${color.midnight[25]};
  box-shadow: 0px 8px 8px -4px rgba(16, 24, 40, 0.03),
    0px 20px 24px -4px rgba(16, 24, 40, 0.08);
  overflow: hidden;
  padding: ${spacing[24]};

  .upkeep-icon {
    width: 80px;
    height: 80px;
    animation: rotate 6s linear infinite;
  }

  p {
    ${font('display', 'xs', '500')}
    color: ${color.darkBlue[1000]};
    text-align: center;
  }

  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
